<template>
  <vx-card class="saved_review mb-2 border shadow-none border-solid">
    <template v-slot:title >
      <div class="m-4">
        <div class="text-3xl flex justify items-center flex-wrap">
          <div class="font-bold mr-2"> {{periodWords}} </div>
          <div class="mr-2">retrospective</div>

          <div>
            <vs-chip size="small" v-if="goodSentiment" color="success" class="m-0">
              good
            </vs-chip>
            <vs-chip size="small" v-else color="danger" class="m-0">
              not so good
            </vs-chip>
          </div>
        </div>

        <div class="flex flex-wrap mt-2">
          <div :key="reflection.question" v-for="reflection in review.reflections">
            <div class="flex flex-col mr-6 mb-4" v-if="reflection.answer">
              <div class="font-bold text-xl">
                {{reflection.questionShort}}
              </div>
              <div>
                {{reflection.answer}}
              </div>
            </div>
          </div>

        </div>
        <slot></slot>
      </div>
    </template>


    <template v-slot:actions>
      <div @click.stop="" class="flex items-center">

          <feather-icon icon="MoreVerticalIcon" @click="openContextMenu" :class="actionElementCss" svgClasses="h-5 w-5" />
          <context-menu id="routines-context-menu" ref="reviewCtxMenu">
            <ContextMenuItem title="edit" icon="EditIcon" @contextMenuClicked="$emit('edit')"/>

            <ContextMenuItem title="delete" icon="Trash2Icon" @contextMenuClicked="$emit('delete')" color="text-danger"/>
          </context-menu>
        </div>
    </template>
  </vx-card>

</template>

<script>
// import JourneyDay from './JourneyDay'
import * as DateHelper from '@/helpers/date'

export default {
  components: {
  },
  props: ['review'],
  data () {
    return {
    }
  },
  computed: {
    periodWords () {
      return DateHelper.periodWord(this.review.from, this.review.to)
    },
    goodSentiment () {
      return this.review.sentiment === 'good'
    }

  },
  methods: {
    openContextMenu () {
      // this.$root.$emit('closeAllContextMenus')

      if (this.$refs.reviewCtxMenu) {
        this.$refs.reviewCtxMenu.open()
      }
    },
  },
  created () {
    this.$root.$on('closeAllContextMenus', () => {
      if (this.$refs.reviewCtxMenu) {
        this.$refs.reviewCtxMenu.ctxVisible = false
      }
    })
  },
}
</script>

<style lang="scss">

.saved_review {
  .vx-card__header {
    padding: 0.6rem
  }
}

</style>
